export interface QueryParams {
  assetCode?: string;
  isCashoutAllowed?: string | boolean;
  cashoutCountry?: string;
  cashoutCurrencies?: string;
  operation?: string;
  token: string;
  transactionId?: string;
  walletProvider?: string;
  amount?: number;
  email?: string;
  locale: string;
  refNumber?: number | string;
  lang?: string;
  endpoint?: string;
}

export interface QueryParamsState {
  queryParams: QueryParams;
}
